"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInstrumentUrlSync = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var useInstrumentUrlSync = exports.useInstrumentUrlSync = function useInstrumentUrlSync(_ref) {
  var instruments = _ref.instruments,
    selectedInstrumentId = _ref.selectedInstrumentId,
    initSelectedInstrument = _ref.initSelectedInstrument,
    _ref$routePrefix = _ref.routePrefix,
    routePrefix = _ref$routePrefix === void 0 ? '/exchange' : _ref$routePrefix;
  var _useParams = (0, _reactRouterDom.useParams)(),
    symbol = _useParams.symbol;
  var history = (0, _reactRouterDom.useHistory)();
  var lastInitializedSymbolRef = (0, _react.useRef)(null);
  var initializedByURLRef = (0, _react.useRef)(false);
  var hasSyncedRef = (0, _react.useRef)(false);
  var getSymbolKey = function getSymbolKey(instrument) {
    return "".concat(instrument.Product1Symbol).concat(instrument.Product2Symbol).toUpperCase();
  };
  (0, _react.useEffect)(function () {
    var upperSymbol = symbol === null || symbol === void 0 ? void 0 : symbol.toUpperCase();
    var selected = instruments.find(function (i) {
      return i.InstrumentId === selectedInstrumentId;
    });
    var selectedSymbol = selected ? getSymbolKey(selected) : '';
    if (!instruments.length) return;
    if (upperSymbol && upperSymbol !== lastInitializedSymbolRef.current) {
      var symbolExists = instruments.some(function (i) {
        return getSymbolKey(i) === upperSymbol;
      });
      initializedByURLRef.current = true;
      hasSyncedRef.current = false;
      lastInitializedSymbolRef.current = upperSymbol;
      if (initializedByURLRef.current) {
        if (!symbolExists) {
          if (selectedSymbol) {
            var targetPath = "".concat(routePrefix, "/").concat(selectedSymbol);
            if (history.location.pathname !== targetPath) {
              history.replace(targetPath);
            }
            lastInitializedSymbolRef.current = selectedSymbol;
            hasSyncedRef.current = true;
          }
          initializedByURLRef.current = false;
          return;
        }
        if (selectedSymbol !== upperSymbol) {
          initSelectedInstrument(upperSymbol);
        }
        hasSyncedRef.current = true;
        initializedByURLRef.current = false;
        return;
      }
      if (!symbolExists) {
        if (selectedSymbol) {
          lastInitializedSymbolRef.current = selectedSymbol;
          history.replace("".concat(routePrefix, "/").concat(selectedSymbol));
        }
        return;
      }
      if (hasSyncedRef.current && selectedSymbol && selectedSymbol !== upperSymbol) {
        lastInitializedSymbolRef.current = selectedSymbol;
        history.push("".concat(routePrefix, "/").concat(selectedSymbol));
      }
      return;
    }
    if (!selectedSymbol) {
      return;
    }
    var nextPath = "".concat(routePrefix, "/").concat(selectedSymbol);
    if (history.location.pathname !== nextPath) {
      history.push(nextPath);
    }
    lastInitializedSymbolRef.current = selectedSymbol;
    hasSyncedRef.current = true;
  }, [symbol, selectedInstrumentId, instruments, initSelectedInstrument, history, routePrefix]);
};